<template>
  <v-dialog persistent eager attach=".shopStartPage"
            :content-class="computedClass"
            v-model="addToCartDialog"
  >

    <template v-slot:activator="{on, attrs}">
      <v-btn
          class="addToInventoryOpenFormBtn leftRounded"
          v-bind ="attrs"
          v-on="on"
          @click="openAddToCart"
          v-if="!formOpen"
      >
        <inventory-icon-white/>
      </v-btn>
      <v-btn
          class="addToInventoryOpenFormBtn closeBtn leftRounded"
          v-bind:class="{elevated: formOpen}"
          v-on="on"
          @click="openAddToCart"
          v-show="$router.currentRoute.name === 'Artikeldetails'"
          v-else-if="formOpen"
      >
        <close-btn/>
      </v-btn>
    </template>

    <v-card class="addToCartCard">
      <v-card-title class="addToCart__title">{{ article.description }}</v-card-title>
      <v-container class="addToCartContainer">
        <v-row>
          <v-col cols="12" >
            <v-chip-group
                class="inventoryTypeSelector"
                v-model="selection"
                mandatory
            >
              <v-chip value="s">
                {{ article.baseUnit | capitalize}}
              </v-chip>
              <v-chip value="m">
                {{ article.packageUnit | capitalize }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer/>
          <v-col cols="12" sm="8" md="6" l="6" xl="6">
            <v-text-field class="centered-input inputAmountSlot"
                          v-model="counter"
                          filled
                          single-line
                          type="number"
                          append-outer-icon="mdi-plus"
                          @click:append-outer="increment"
                          prepend-icon="mdi-minus"
                          @click:prepend="decrement"
                          dense
                          v-on:blur="checkAmount"
            >
            </v-text-field>
          </v-col>
          <v-spacer/>
        </v-row>
        <v-row>
        <v-col cols="8">
          <v-btn class="addToInventoryFormButton"
                 @click="addToInventory"
          >
            <inventory-icon-white/>
            <span class="pl-3 text--white">Zur Inventurliste hinzufügen</span>
          </v-btn>
        </v-col>
        <v-col cols="4" class="addToCartCloseWrap">
          <v-btn class="addToCartCloseBtnList closeBtn leftRounded"
                  @click="closeDialog"
                 v-if="$router.currentRoute.name !== 'Artikeldetails'"
          >
              <close-btn/>
          </v-btn>
        </v-col>
        </v-row>
      </v-container>
    </v-card>

  </v-dialog>
</template>

<script>
import {mapActions} from 'vuex'
import CloseBtn from "@/assets/closeBtn";
import InventoryIconWhite from "@/assets/inventory/inventoryIconWhite";
export default {
  props: ['article'],
  name: "addToInventory",
  components: {InventoryIconWhite, CloseBtn},

  data:() => {
    return{
      counter: 1,
      formOpen: false,
      selection: 's',
      addToCartDialog: false,
    }
  },

  methods: {
    ...mapActions('inventory', {
      addArticleToInventory: 'addArticleToInventory',
      addArticleToPersonalInventory: 'addArticleToPersonalInventory'
    }),

    setDialogScrollLock(isLocked) {
      const body = document.body
      const shopStartPage = document.querySelector('.shopStartPage')
      const currentLocks = Number(body.dataset.dialogScrollLock || 0)
      const nextLocks = isLocked ? currentLocks + 1 : Math.max(currentLocks - 1, 0)

      body.dataset.dialogScrollLock = String(nextLocks)
      body.classList.toggle('dialog-scroll-locked', nextLocks > 0)

      if (shopStartPage) {
        shopStartPage.classList.toggle('dialog-scroll-locked', nextLocks > 0)
      }
    },

    openAddToCart() {
      if(!this.formOpen) {
        this.formOpen = true,
        this.counter = 1
      }
      else if (this.formOpen){
        this.formOpen = false
      }
    },

    increment() {
      this.counter += 1
    },
    decrement() {
      this.counter > 0 ? this.counter -= 1 : this.counter = 0
    },
    checkAmount: function(){
      if(this.counter < 0){
        this.counter = 0
      }
    },

    addToInventory() {
      let params = {
        artNr: this.article.itemNo,
        amount: this.counter,
        type: this.selection
      }

      this.addArticleToPersonalInventory(params)
      this.addToCartDialog = false
      this.openAddToCart()
    },

    closeDialog() {
      this.formOpen = !this.formOpen
      this.addToCartDialog = !this.addToCartDialog
    }
  },

  computed: {
    computedClass() {
      let className = 'addToCartDialog'

      if(this.$router.currentRoute.name === 'Watchlist') {
        className = 'addToCartDialogList'
      }
      return className
    }
  },

  watch: {
    addToCartDialog(isOpen) {
      this.setDialogScrollLock(isOpen)
    }
  },

  beforeDestroy() {
    if (this.addToCartDialog) {
      this.setDialogScrollLock(false)
    }
  }
}
</script>

<style>
  .addToCart__title {
    display: inline-block;
  }
</style>
